import { actionTypes } from './action';

export const initialAnnouncementState = {
    eventBanners: [],
    stickyHeaders: [],
    popups: [],
    gameUpdates: [],
    displays: [],
};

const announcementsReducer = (state = initialAnnouncementState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_ANNOUNCEMENTS:
            return {
                ...state,
                ...action.payload, // Updates only the provided fields
            };
        case actionTypes.SET_POPUP_DISPLAY:
            return {
                ...state,
                displays: state.displays.some((popup: { popupId: number }) => popup.popupId === action.payload.popupId)
                    ? state.displays.map((popup: { popupId: number }) =>
                        popup.popupId === action.payload.popupId ? { ...popup, ...action.payload } : popup
                    )
                    : [...state.displays, action.payload],
            };
        case actionTypes.CLEAR_ANNOUNCEMENTS:
            return { ...initialAnnouncementState }; // Resets everything to an empty state

        default:
            return state;
    }
};

export default announcementsReducer;